import catalogPlugin from '@backstage/plugin-catalog/alpha';
import { PageShareTitle } from '../../lib/shareTitle';

/**
 * Override of the catalog plugin's `page:catalog` extension that swaps the
 * stock `CatalogIndexPage` for our kit-style `RegaskCatalogPage` (see
 * RegaskCatalogPage.tsx). The page brings its own chrome (breadcrumb,
 * header, kind tabs, filter pills), so the PageLayout header is disabled
 * (`noHeader`) and the stock `filters` input / `pagination` config are no
 * longer wired in: filtering is reimplemented on the headless
 * catalog-react primitives, with the All pill as the initial user filter —
 * the same behavior the `catalog-filter:catalog/list` `initialFilter: all`
 * app-config gave the stock page.
 */
export const catalogIndexPage = catalogPlugin
  .getExtension('page:catalog')
  .override({
    factory(originalFactory) {
      return originalFactory({
        params: {
          noHeader: true,
          loader: async () => {
            const { RegaskCatalogPage } = await import('./RegaskCatalogPage');
            return (
              <PageShareTitle title="Catalog">
                <RegaskCatalogPage />
              </PageShareTitle>
            );
          },
        },
      });
    },
  });
